import { render } from "./DictionaryFieldList.vue?vue&type=template&id=23dc8595"
import script from "./DictionaryFieldList.vue?vue&type=script&lang=js"
export * from "./DictionaryFieldList.vue?vue&type=script&lang=js"

import exportComponent from "/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__